/**
 * Theme Helpers
 * -----------------------------------------------------------------------------
 * Collection of utility methods
 */

// Detect touch devices
var touchDevice = false;

var classes = {
  preventScrolling: 'prevent-scrolling'
};

var scrollPosition = window.pageYOffset;

function setTouch() {
  touchDevice = true;
}

export function isTouch() {
  return touchDevice;
}

// Handleize
export function handleize(str) {
  return str
    .toLowerCase()
    .replace(/[^\w\u00C0-\u024f]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// Debounce
export function debounce(func, wait, immediate) {
  var timeout;

  return function() {
    var context = this,
      args = arguments;

    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

/* Based on the prepareTransition by Jonathan Snook */
/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
export function prepareTransition(element) {
  element.addEventListener(
    'transitionend',
    function(event) {
      event.currentTarget.classList.remove('is-transitioning');
    },
    { once: true }
  );

  var properties = [
    'transition-duration',
    '-moz-transition-duration',
    '-webkit-transition-duration',
    '-o-transition-duration'
  ];

  var duration = 0;

  properties.forEach(function(property) {
    var computedValue = getComputedStyle(element)[property];

    if (computedValue) {
      computedValue.replace(/\D/g, '');
      duration || (duration = parseFloat(computedValue));
    }
  });

  if (duration !== 0) {
    element.classList.add('is-transitioning');
    element.offsetWidth;
  }
}

/**
 * https://gomakethings.com/how-to-test-if-an-element-is-in-the-viewport-with-vanilla-javascript/
 * 
 * var h1 = document.querySelector('h1');
 * if (isInViewport(h1)) {
 *  // do something
 * }
 * 
 * @param {*} element 
 */

export function isInViewport(element) {
  var bounding = element.getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
};